// src/app/components/searchCompanies/FavouritesMessage.js

import React, { Component } from "react";

import { JARGON, KIND } from "../../modules/constants"

import { withStyles } from "@mui/styles"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"

const styles = theme => ({
  box: {
    paddingTop: 16,
    paddingLeft: 20
  },
  messageTitle: {
    fontSize: 18,
    fontWeight: "bold",
  },
  messageHeading: {
    fontSize: 16,
    fontWeight: "bold",
    paddingTop: 24,
  },
  messageText: {
    fontSize: 16,
    paddingTop: 12,
  },
})

class FavouritesMessage extends Component {

  render() {
    const { classes, favouriteKind } = this.props;
    const favouriteType = favouriteKind === KIND.FAVOURITE.COMPANIES ? JARGON.COMPANY.toLowerCase() : JARGON.PERSON.toLowerCase()
    const otherType = favouriteKind === KIND.FAVOURITE.COMPANIES ? JARGON.PERSON.toLowerCase() : JARGON.COMPANY.toLowerCase()
    const favouriteTypePlural = favouriteKind === KIND.FAVOURITE.COMPANIES ? JARGON.COMPANIES.toLowerCase() : JARGON.PEOPLE.toLowerCase()

    return (
      <Box className={classes.box}>
        
        <Typography className={classes.messageTitle}>
          You'll see your list of favourite {favouriteTypePlural} here - but you haven't added any yet!
        </Typography>

        <Typography className={classes.messageHeading}>
          To add a favourite:
        </Typography>

        <Typography className={classes.messageText}>
          search for a {favouriteType} and click through to their {favouriteType} page
        </Typography>

        <Typography className={classes.messageText}>
          or go to the {favouriteType}'s page by clicking through from a {otherType} that they are associated with
        </Typography>

        <Typography className={classes.messageText}>
          then click on the star next to the name
        </Typography>

        <Typography className={classes.messageHeading}>
          To remove a favourite:
        </Typography>

        <Typography className={classes.messageText}>
          click on the star by their name, here in the favourite {favouriteTypePlural} list
        </Typography>

        <Typography className={classes.messageText}>
          or on their {favouriteType} page
        </Typography>

      </Box>
    )
  }
}

export default withStyles(styles)(FavouritesMessage);